import {
  ASK_NOTIFICATION_PERMISSION,
  CLEAR_NOTIFICATION_PERMISSION,
  NOTIFICATION_POPUP_SHOWN
} from "../actions";

export default function firebaseDetails(state = {}, action) {
  let newState = { ...state };
  switch (action.type) {
    case ASK_NOTIFICATION_PERMISSION:
      newState["askNotificationPermission"] = true;
      return newState;
    case CLEAR_NOTIFICATION_PERMISSION:
      newState["askNotificationPermission"] = false;
      newState["notificationPopupShown"] = true;
      return newState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/firebaseDetails.js